var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapseNodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#5E6C84"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3333 12.8889C16.8424 12.8889 16.4444 13.2869 16.4444 13.7778V14.6667H23.5555V13.7778C23.5555 13.2869 23.1576 12.8889 22.6666 12.8889H17.3333ZM25.3333 14.8184V13.7778C25.3333 12.305 24.1394 11.1111 22.6666 11.1111H17.3333C15.8605 11.1111 14.6666 12.305 14.6666 13.7778V14.8184C13.6309 15.1845 12.8889 16.1723 12.8889 17.3333V18.374C11.8531 18.74 11.1111 19.7278 11.1111 20.8889V26.2222C11.1111 27.695 12.305 28.8889 13.7778 28.8889H26.2222C27.695 28.8889 28.8889 27.695 28.8889 26.2222V20.8889C28.8889 19.7278 28.1468 18.74 27.1111 18.374V17.3333C27.1111 16.1723 26.369 15.1845 25.3333 14.8184ZM25.3333 18.2222V17.3333C25.3333 16.8424 24.9354 16.4444 24.4444 16.4444H15.5555C15.0646 16.4444 14.6666 16.8424 14.6666 17.3333V18.2222H25.3333ZM13.7778 20C13.2868 20 12.8889 20.398 12.8889 20.8889V26.2222C12.8889 26.7132 13.2868 27.1111 13.7778 27.1111H26.2222C26.7131 27.1111 27.1111 26.7132 27.1111 26.2222V20.8889C27.1111 20.3979 26.7131 20 26.2222 20H13.7778Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseNodeIcon);
export default __webpack_public_path__ + "static/media/collapse_node_icon.fddb3bef1ff46d4197b08c235c397370.svg";
export { ForwardRef as ReactComponent };